import jsPDF from 'jspdf';

class ReportPdf {
    margins = {};
    header = {};
    headerHeight = 0;
    footerHeight = 0;
    contentMargin = {
        top: 0,
        bottom: 0,
        left: 0,
        right: 0
    }
    spacing = {
        sm: 5,
        md: 10,
        l: 15,
        xl: 20,
    };

    constructor(margins = {}, format = 'a4') {
        Object.assign(this, new jsPDF('p', 'pt', format));
        this.setMargins(margins, 1);
        this.bounds = {
            width: this.internal.pageSize.width,
            height: this.internal.pageSize.height,
        };
        this.x = this.margins.left;
        this.y = this.margins.top;

        this.setFont('Times');
        this.setFontSize(11);

        this.initialisePageState();
    }

    initialisePageState = () =>
        (this.state = {
            currentLine: 1,
            currentLinePos: this.getMargins(this.getCurrentPageNumber()).left,
        });

    getMargins = (pageNumber = 1) =>
        this.margins[pageNumber] || this.margins[1];
    setMargins = (margins, pageNumber = 1) =>
        (this.margins[pageNumber] = {
            left: this.spacing.xl,
            right: this.spacing.xl,
            top: this.spacing.xl,
            bottom: this.spacing.l,
            ...margins,
        });
    getState = () => this.state;
    setState = (state) => (this.state = state);

    // TODO: Rename these to getCurrentYPosition and setCurrentYPosition etc
    // since the line number has nothing to do with it
    getCurrentLinePosition = () => this.state.currentLinePos;
    setCurrentLinePosition = (currentLinePosition) =>
        (this.state.currentLinePos = currentLinePosition);
    incrementCurrentLinePositionBy = (amount) =>
        (this.state.currentLinePos += amount);
    decrementCurrentLinePositionBy = (amount) =>
        (this.state.currentLinePos -= amount);

    getCurrentLine = () => this.state.currentLine;
    setCurrentLine = (currentLine) => (this.state.currentLine = currentLine);
    incrementCurrentLineBy = (amount) => (this.state.currentLine += amount);
    decrementCurrentLineBy = (amount) => (this.state.currentLine -= amount);
    getSavedSectionHeading = () => this.state.savedSectionHeading;
    setSavedSectionHeading = (sectionHeading) =>
        (this.state.savedSectionHeading = sectionHeading);
    horizontalRule = () => {
        this.line(
            0,
            this.getCurrentLinePosition(),
            this.getPageWidth(),
            this.getCurrentLinePosition(),
            'S'
        );
    };

    baseJsPdfAddPage = this.addPage;
    addPage = (margins) => {
        this.baseJsPdfAddPage();
        this.setMargins(
            (this.margins = {
                ...this.getMargins(1),
                ...margins,
            }),
            this.getCurrentPageNumber()
        );
    };

    getCurrentPageNumber = () => this.internal.getCurrentPageInfo().pageNumber;

    getHeaderHeight = () => this.headerHeight || 0;
    setHeaderHeight = (height) => (this.headerHeight = height);

    getFooterHeight = () => this.footerHeight || 0;
    setFooterHeight = (height) => this.footerHeight = height;

    getFooterStartY = (pageNumber) => {
        const footerHeight = this.getFooterHeight(pageNumber);
        return (
            this.pageHeight - this.getMargins(pageNumber).bottom - footerHeight
        );
    };

    getContentStartY = () => this.getHeaderHeight(pageNumber) + this.contentMargin.top;
    getContentEndY = () => this.getPageHeight() - this.getFooterHeight() - this.contentMargin.bottom;
}

export default ReportPdf;
